import { FC, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
// import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
// import { PreStudent } from "../../types/slices/preStudentsType";
import { usePreStudentStore } from "../../hooks/usePreStudentStore";

const columns = [
  // { type: "options", field: "options", label: "Opciones", align: "center" },
  { type: "text", field: "course", label: "CURSO", align: "start" },
  { type: "text", field: "student", label: "ESTUDIANTE", align: "start" },
  { type: "text", field: "type_document", label: "TIPO DOCUMENTO", align: "center" },
  { type: "text", field: "document_number", label: "NRO. DOCUMENTO", align: "center" },
  { type: "text", field: "email", label: "CORREO", align: "start" },
  { type: "text", field: "phone", label: "CELULAR", align: "end" },
  { type: "text", field: "institution", label: "INSTITUCION", align: "start" },
  { type: "text", field: "date", label: "FECHA", align: "center" },
];

const PreStudentsView: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  // const [rowSelected, setRowSelected] = useState<PreStudent>({} as PreStudent);
  // const [modalDeleteConfirm, setModalDeleteConfirm] = useState<boolean>(false);

  const {
    preStudents,
    statusPreStudents,
    getPreStudents,
    getPreStudentsSearch,
  } = usePreStudentStore();

  useEffect(() => {
    setLoading(true);
    getPreStudents().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onSearch = (value) => {
    if (value.length >= 1) {
      getPreStudentsSearch(value);
    }
    if (value.length === 0) {
      getPreStudents();
    }
  };

  return (
    <>
      {statusPreStudents === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
      <Grid item xs={12}>
        <CustomTable
          title={"Inscripciones"}
          columns={columns}
          loading={loading}
          rows={preStudents || []}
          // onRowClick={() => {}}
          // onAddFn={() => {}}
          // onDelete={() => {}}
          // onEdit={() => {}}
          onSearch={onSearch}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Grid>
    </>
  );
};

export default PreStudentsView;